import React from 'react';
import { GridOverlay } from '@mui/x-data-grid';
import { Typography } from '@mui/material';

const CustomNoRowsOverlay = () => {
  return (
    <GridOverlay>
      <Typography variant="h6" component="div">
        No records found
      </Typography>
    </GridOverlay>
  );
};

export default CustomNoRowsOverlay;
